import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { backendApiAuthenticationGetUser } from '@/modules/api/backend';
import { backendApiAuthenticationGetUserQueryKey } from '@/modules/api/backend/@tanstack/react-query.gen';

type UserData = Awaited<ReturnType<typeof backendApiAuthenticationGetUser>>['data'] | null;

export function useOptionalUserQuery(): UseQueryResult<UserData> {
  return useQuery<UserData>({
    queryKey: backendApiAuthenticationGetUserQueryKey(),
    queryFn: async ({ signal }) => {
      try {
        const { data } = await backendApiAuthenticationGetUser({
          signal,
          throwOnError: false,
        });

        return data ?? null;
      } catch {
        return null;
      }
    },
    retry: false,
  });
}
